module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/x-62937d1bd0fc1ca3b458efd5cfb749fe.svg";